"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const TableHead_1 = __importDefault(require("@mui/material/TableHead"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableHeader = ({ columns, classes }) => (<TableHead_1.default>
    <TableRow_1.default>
      {Object.keys(columns).map((key) => {
        const column = columns[key];
        return (<TableCell_1.default key={key} className={(0, classnames_1.default)(classes.resetCell, classes === null || classes === void 0 ? void 0 : classes[key])}>
            <div className={classes === null || classes === void 0 ? void 0 : classes[`${key}Container`]}>{column.label}</div>
          </TableCell_1.default>);
    })}
    </TableRow_1.default>
  </TableHead_1.default>);
exports.default = react_1.default.memo(TableHeader);
